@let responseValue = response();
@let isLoadingValue = isLoading();

<div class="header">
  <div class="header-title">
    <rt-badge color="ai" [text]="'app.common.ai' | translate" />
    <span>{{
      (responseValue?.content
        ? 'tlc.positions.position_details_dialog.tabs.description.ai_generator.header_with_response'
        : 'tlc.positions.position_details_dialog.tabs.description.ai_generator.header_initial'
      ) | translate
    }}</span>
  </div>
  <rt-icon-button iconName="close" variant="plain" size="small" (click)="onCloseClick()" />
</div>

<div class="content">
  @if (isLoadingValue) {
    <div class="loading-container">
      <rt-placeloader variant="ai-text" />
      <rt-placeloader variant="ai-text" />
      <rt-placeloader variant="ai-text" />
    </div>
  } @else if (!!responseValue) {
    <div class="response-container">
      <div
        class="response"
        prosemirrorRichConfig
        [prosemirrorRender]="contentJson()"
        [prosemirrorRenderConfig]="ProsemirrorRichConfig"
      ></div>
      <div class="footer">
        <rt-button (click)="onInsertClicked()">
          <rt-icon name="check" colorToken="colorIconSuccessDefault" />
          <span>{{
            'tlc.positions.position_details_dialog.tabs.description.ai_generator.insert' | translate
          }}</span>
        </rt-button>
        <rt-button variant="outline" (click)="onReplaceClicked()">
          <span>{{
            'tlc.positions.position_details_dialog.tabs.description.ai_generator.replace'
              | translate
          }}</span>
        </rt-button>
      </div>
    </div>
    <div class="improve-section">
      <form [formGroup]="improveForm">
        <div class="button-input" [class.focused]="improveFocused()">
          <rt-input
            variant="plain"
            [placeholder]="
              'tlc.positions.position_details_dialog.tabs.description.ai_generator.improve_placeholder'
                | translate
            "
            (keydown.enter)="onImproveClicked()"
            formControlName="prompt"
            (focus)="improveFocused.set(true)"
            (blur)="improveFocused.set(false)"
            type="text"
            [preventAutocompleteSuggestions]="true"
          />
          @if (improvePromptControl.dirty && improvePromptControl.value) {
            <rt-button size="small" (click)="onImproveClicked()">
              <rt-icon name="arrow-upward" colorToken="colorIconAiDefault" />
              <span>{{
                'tlc.positions.position_details_dialog.tabs.description.ai_generator.improve_button'
                  | translate
              }}</span>
            </rt-button>
          } @else {
            <div class="icon-wrapper">
              <rt-icon name="arrow-upward" colorToken="colorIconDisabled" />
            </div>
          }
        </div>
      </form>
    </div>
  } @else {
    <form [formGroup]="form">
      <div class="button-input" [class.focused]="focused()">
        <rt-input
          variant="plain"
          [placeholder]="
            'tlc.positions.position_details_dialog.tabs.description.ai_generator.prompt_placeholder'
              | translate
          "
          (keydown.enter)="onGenerateClicked()"
          formControlName="prompt"
          (focus)="focused.set(true)"
          (blur)="focused.set(false)"
          type="text"
          [preventAutocompleteSuggestions]="true"
        />
        @if (promptControl.value?.trim()) {
          <rt-button size="small" (click)="onGenerateClicked()">
            <rt-icon name="arrow-upward" colorToken="colorIconAiDefault" />
            <span>{{
              'tlc.positions.position_details_dialog.tabs.description.ai_generator.generate_button'
                | translate
            }}</span>
          </rt-button>
        } @else {
          <div class="icon-wrapper">
            <rt-icon name="arrow-upward" colorToken="colorIconDisabled" />
          </div>
        }
      </div>
    </form>
    <span class="info">
      {{
        'tlc.positions.position_details_dialog.tabs.description.ai_generator.prompt_info'
          | translate
      }}
    </span>
  }
</div>
